import { useEffect, useState } from 'react';
import { media } from '../context/media';

export function useDeviceSize(): boolean {
	const [isMobileDevice, setIsMobileDevice] = useState(true);

	useEffect(() => {
		function handleResize() {
			const windowWidth = window.innerWidth;
			setIsMobileDevice(windowWidth <= media.phoneMaxWidth);
		}

		handleResize();

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return isMobileDevice;
}
